import { useState } from 'react';
import { Data } from 'signup-constants/signupData/Data';
import { DataOptions } from '../signup-data/signupDataOptions';
import { BaseButtonsView } from './BaseButtonsView';
import { ManagementLevel } from 'signup-constants/signupData/ManagementLevel';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { useExperiment, TrackWhen } from '../experiments/useExperiment';
import { useSignupData } from '../signup-data/useSignupData';
import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import { useTracker } from '../tracking/useTracker';
import { useSelector } from 'react-redux';
import { getPredictedTypeaheadValues } from '../store/typeahead/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
const CompanySizeView = () => {
  const options = DataOptions[Data.CompanySize];
  const {
    setData: setManagementLevel,
    data: managementLevel
  } = useSignupData(Data.ManagementLevel);
  const {
    data: companySize,
    isPrefilled
  } = useSignupData(Data.CompanySize);
  const [companySizeChosenOnLoad] = useState(companySize);
  const {
    isAssignedToVariant: isAssignedToVariantACQ143
  } = useExperiment(ExperimentKeys.ACQ0143, TrackWhen.never);
  const shouldShowPrefill = isPrefilled && isAssignedToVariantACQ143();
  const Tracker = useTracker();
  const predictedCompanySize = useSelector(state => getPredictedTypeaheadValues(state, Data.CompanySize));
  const onSelect = value => {
    if (isPrefilled && predictedCompanySize && predictedCompanySize[0] && companySize !== predictedCompanySize[0]) {
      Tracker.signupInteraction('company-size-changed-prefill', {
        selectedOption: [value],
        previousValue: predictedCompanySize[0]
      });
    }

    /*
      If the user has previously chosen Company Size 1
      and Owner has automatically been pre-filled, this
      resets that to prevent Owner being pre-selected
      on the management level step when company size is changed from 1
    */

    if (isAssignedToVariantACQ143() && managementLevel === ManagementLevel.Owner && companySizeChosenOnLoad === CompanySizeOption.One && companySize !== CompanySizeOption.One) {
      setManagementLevel('');
    }
  };
  return /*#__PURE__*/_jsx(BaseButtonsView, {
    columnCount: isAssignedToVariantACQ143() ? 2 : undefined,
    hasNextButton: shouldShowPrefill,
    options: options,
    shouldCenterLastRow: !isAssignedToVariantACQ143(),
    shouldDisableAutofocus: true,
    shouldShowHelperText: shouldShowPrefill,
    type: shouldShowPrefill ? 'radio' : 'default',
    onSelect: onSelect
  });
};
export default CompanySizeView;